<template lang="pug">
  #ReservationIndex
    b-card.rounded-0.mb-3(
      bg-variant="light",
      no-body
    )
      b-row(
        no-gutters
        class="mb-3 px-2 button-row"
      )
        multiselect.multiselect__dark.m-3(
          v-model="nowSelectStatus",
          placeholder="請選擇預約狀態",
          selectedLabel="已選擇",
          selectLabel="點擊選擇預約狀態",
          :options="statusList",
          :allow-empty="false"
          noOptions="無預約狀態"
          label="name"
          :searchable="false"
          @input="changeStatusHandler"
        )
          template(slot="noOptions")
            strong 無預約狀態
        .mx-3.total 共 {{ pagination.total }} 筆

    .px-3
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="light",
        v-for="(reservation,index) in reservations",
        :key="reservation.reservation_id"
      )
        .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
          .col-6.pr-1
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="reservation.picture_url",
              :style="{ 'width': '80px', 'height': '80px' }"
            )
          .col-6.pl-1
            p.mb-0.font-weight-bold 姓名 {{ reservation.name }}
            p.mb-0 暱稱名 {{ reservation.line_name }}
        .reserveAtRow.mb-2.d-flex.align-items-center
          i.far.fa-calendar-check.mr-2
          small 預約時間：{{ reservation.reserve_date }} {{ reservation.start_time }}
        .typeRow.mb-2.d-flex.align-items-center
          i.fas.fa-border-all.mr-2
          small 服務內容：{{ reservation.reserve_type_name }}
        b-row(
          no-gutters
        )
          b-col(
            :cols="4",
            class="d-flex justify-content-end",
            v-if="reservation.status === 'checked'"
          )
            b-button.rounded-50(
              size="sm",
              variant="primary",
              @click="cancelReservationHandler(reservation.reservation_id)"
            ) 取消預約
          b-col(
            cols=4,
            class="d-flex justify-content-center",
            v-if="reservation.status === 'checked'"
          )
            b-button.rounded-50(
              size="sm",
              variant="primary",
              @click="editReservationHandler(reservation)"
            ) 修改預約
          b-col(
            cols=12,
            class="d-flex justify-content-center",
            v-if="reservation.status === 'checking'"
          )
            b-button.rounded-50(
              size="sm",
              variant="primary",
              @click="confirmReservationHandler(reservation.reservation_id)"
            ) 完成預約
          b-col(
            cols=4,
            class="pl-1",
            v-if="reservation.status === 'checked'"
          )
            b-button.rounded-50(
              size="sm",
              variant="primary",
              @click="doneReservationHandler(reservation.reservation_id)"
            ) 到店諮詢
        .labelTag(
          v-if="reservation.status === 'expired'",
          style="right: 0;bottom: 0;"
        )
          span.labelTag__text 已過期
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SM_RESERVATION_EDIT } from '@/router/sm/reservation';

export default {
  name: 'ReservationIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      searchInput: {
        customer_name: null,
        reservation_date: null
      },
      nowSelect: 'checking',
      infiniteId: +new Date(),
      statusList: [
        {
          id: 'checking',
          name: '確認中'
        },
        {
          id: 'checked',
          name: '完成預約'
        },
        {
          id: 'success',
          name: '到店諮詢'
        },
        {
          id: 'expired',
          name: '已過期'
        }
      ],
      nowSelectStatus: null,
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.nowSelectStatus = vm.statusList[0];
    vm.$store.commit('sm_reservation/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('sm_reservation/getReservationTimeListHandler');
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('sm_reservation/getReservationHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        status: vm.nowSelect,
        customer_name: vm.searchInput.customer_name,
        reservation_date: vm.searchInput.reservation_date
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeStatusHandler(val) {
      const vm = this;
      switch (val.id) {
        case 'checked':
          if (vm.nowSelect === 'checked') return;
          vm.nowSelect = 'checked';
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checking':
          if (vm.nowSelect === 'checking') return;
          vm.nowSelect = 'checking';
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'success':
          if (vm.nowSelect === 'success') return;
          vm.nowSelect = 'success';
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'expired':
          if (vm.nowSelect === 'expired') return;
          vm.nowSelect = 'expired';
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    cancelReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '取消預約中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sm_reservation/deleteHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '取消確認成功');
        });
    },
    editReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SM_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          editInfo: reservation
        }
      });
    },
    confirmReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '預約確認中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sm_reservation/checkHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '預約確認成功');
        });
    },
    doneReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '處理中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sm_reservation/successHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '到店諮詢成功');
        });
    },
    searchHandler() {
      const vm = this;
      if (!vm.searchInput.customer_name && !vm.searchInput.reservation_date) return;
      vm.$store.commit('sm_reservation/resetHandler');
      vm.infiniteId += 1;
    },
    researtSearchHandler() {
      const vm = this;
      vm.searchInput.customer_name = null;
      vm.searchInput.reservation_date = null;
      vm.$store.commit('sm_reservation/resetHandler');
      vm.infiniteId += 1;
    }
  },
  computed: {
    ...mapState({
      reservations: (state) => state.sm_reservation.reservations,
      reservationTimeList: (state) => state.sm_reservation.reservationTimeList,
      pagination: (state) => state.sm_reservation.pagination
    })
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}

.total {
  font-size: 0.8rem;
  font-weight: 200;
}
</style>
